import { createContext, Dispatch } from 'react'
import { OrgNotificationProviderAction, OrgNotificationProviderState } from './types'

export const OrgNotificationProviderContext = createContext<{
    state: OrgNotificationProviderState
    dispatch: Dispatch<OrgNotificationProviderAction>
}>(null!)
